import React from 'react';
import ConfirmDialog from 'dialogs/ConfirmDialog';
import { DialogProps } from '@material-ui/core';
import { IRealEstateEvent } from '../interfaces';
import { useCloseRealEstateEvent } from '../hooks';

interface IProps extends DialogProps {
  realEstateEvent: IRealEstateEvent;
  onClose(): void;
  onCloseEvent?(): void;
}

const CloseRealEstateEventDialog = ({ realEstateEvent, onCloseEvent, onClose, ...props }: IProps) => {
  const { closeEventState, handleCloseEvent } = useCloseRealEstateEvent(realEstateEvent.realEstateEventId!, () => {
    onClose();
    if (onCloseEvent) onCloseEvent();
  });

  return (
    <ConfirmDialog
      {...props}
      title="Вы уверены, что хотите завершить событие?"
      disabled={closeEventState.loading}
      onConfirm={handleCloseEvent}
      onClose={onClose}
    />
  );
};

export default CloseRealEstateEventDialog;
